import styled from 'styled-components';
import { SwitchGroupMixin } from '../../mixins/components/SwitchGroupMixin';
export var StyledSwitchGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledSwitchGroup",
  componentId: "c11n-8-111-1__sc-10lu0n5-0"
})(["", ""], SwitchGroupMixin);